module.exports = __webpack_public_path__ + "static/media/GE.a0b38df2.png";